<template>
    <div class="d-flex flex-column">
        <label class="fs-7 transition" :class="{'text-primary': isFocused}" v-if="isLabeled">{{label}}</label>
        <div class="d-flex flex-row position-relative input-wrapper p-25 mb-50 w-100" :class="{'focus': isFocused }">
            <i v-if="hasIcon" class="position-absolute md-icon" style="top:0" :class="'icon-'+icon"></i>
            <span v-if="hasPrefix" class="position-absolute" :class="{'text-primary': isFocused}" :style="`left:${hasIcon ? '2.25rem': 0};transition:color .3s ease`">{{prefix}}</span>
            <input v-bind="$attrs" :type="type" :name="name" @input="handleInput" :value="modelValue" :disabled="isDisabled" :placeholder="placeholder" :class="{'disabled': isDisabled , 'ps-250': hasIcon && ! hasPrefix , 'ps-400': hasIcon && hasPrefix}" @focus="isFocused=true" @blur="isFocused=false" />
        </div>
        <small>{{error}}</small>
    </div>
</template>

<script>
    export default{
        props:{
            icon:{
                type: String,
                default : null
            },
            name:{
                type: String,
                default: ''
            },
            type:{
                type: String,
                default: 'text',
                validation:(value)=>{
                    ['color', 'date', 'datetime-local', 'email', 'number', 'password', 'search', 'tel', 'text', 'url', 'week'].includes(value)
                }
            },
            modelValue:{
                required:true,
            },
            labeled:{
                type:[String, Boolean],
                default: true,
                validation: (value)=>{
                    return ['true', true, false, 'false'].includes(value)
                }
            },
            prefix: {
                type: String,
                default: ''
            },
            label:{
                type: String,
                default:''
            },
            error:{
                type: String,
                default: null
            },
            disabled:{
                type:[String, Boolean],
                default:false,
                validation:(value)=>{
                    return [true, false, 'true', 'false'].includes(value)
                }
            },
            placeholder:{
                type: String,
                default: ''
            }
        },
        computed:{
            isDisabled(){
                return ['true', true].includes(this.disabled)
            },
            isLabeled(){
                return ['true', true].includes(this.labeled)
            },
            hasIcon(){
                return this.icon !== null
            },
            hasPrefix(){
                return !!this.prefix
            }
        },
        data(){
            return {
                isFocused: false
            }
        },
        methods:{
            handleInput(e){
                this.$emit('input', e)
                this.$emit('update:modelValue', e.target.value)
            }
        }
    }
</script>